module.exports = __webpack_public_path__ + "img/carplaceholder.37980213.png";